import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  updateDoc,
  doc,
} from "firebase/firestore";

import "./AdminBetsWrongPay.css";

export default function AdminBetWrongPay() {
  const [bets, setBets] = useState([]);
  const [users, setUsers] = useState({});
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  // ======= CHAGUA TAREHE NA MUDA =======
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTime, setSelectedTime] = useState("");

  const balanceFields = {
    tshBalance: 0,
    usdtBalance: 0,
    KESBalance: 0,
    UGXBalance: 0,
    RWFBalance: 0,
    BIFBalance: 0,
    ZMWBalance: 0,
    MWKBalance: 0,
    MZNBalance: 0,
    USDBalance: 0,
    SSPBalance: 0,
    BWPBalance: 0,
    MGABalance: 0,
  };

  useEffect(() => {
    if (selectedDate && selectedTime) {
      loadData();
    }
  }, [selectedDate, selectedTime]);
  const showMessage = (msg) => {
    setMessage(msg);
    setTimeout(() => setMessage(""), 5000);
  };

  async function loadData() {
    if (!selectedDate || !selectedTime) {
      showMessage("Chagua tarehe na muda kwanza");
      return;
    }
  
    setLoading(true);
  
    try {
      const betsSnap = await getDocs(collection(db, "antscore"));
  
      const betList = betsSnap.docs
        .map((d) => ({
          id: d.id,
          ...d.data(),
        }))
        .filter((bet) => {
          return (
            bet.matchDate === selectedDate &&
            bet.matchTime === selectedTime
          );
        });
  
      setBets(betList);
  
      const usersSnap = await getDocs(collection(db, "users"));
  
      const map = {};
  
      usersSnap.docs.forEach((d) => {
        const data = d.data();
  
        if (data.username) {
          map[data.username] = {
            id: d.id,
            ...data,
          };
        }
      });
  
      setUsers(map);
  
      showMessage(`${betList.length} bets zimepatikana`);
    } catch (err) {
      console.error(err);
      showMessage("Failed to load");
    }
  
    setLoading(false);
  }
  // ==========================
  // RESET USER MMOJA
  // ==========================

  async function resetUser(username) {
    const user = users[username];
  
    if (!user) return;
  
    try {
      // Bets zote za user kwenye mechi uliyochagua
      const userBets = bets.filter(
        (bet) => bet.username === username
      );
  
      const updates = {
        ...balanceFields,
      };
  
      // Jumlisha totalWin kwa kila currency
      userBets.forEach((bet) => {
        const win = Number(bet.totalWin || 0);
  
        switch (bet.currency) {
          case "TZS":
            updates.tshBalance += win;
            break;
  
          case "USDT":
            updates.usdtBalance += win;
            break;
  
          case "KES":
            updates.KESBalance += win;
            break;
  
          case "UGX":
            updates.UGXBalance += win;
            break;
  
          case "RWF":
            updates.RWFBalance += win;
            break;
  
          case "BIF":
            updates.BIFBalance += win;
            break;
  
          case "ZMW":
            updates.ZMWBalance += win;
            break;
  
          case "MWK":
            updates.MWKBalance += win;
            break;
  
          case "MZN":
            updates.MZNBalance += win;
            break;
  
          case "USD":
            updates.USDBalance += win;
            break;
  
          case "SSP":
            updates.SSPBalance += win;
            break;
  
          case "BWP":
            updates.BWPBalance += win;
            break;
  
          case "MGA":
            updates.MGABalance += win;
            break;
  
          default:
            break;
        }
      });
  
      await updateDoc(doc(db, "users", user.id), updates);
  
      showMessage(`${username} balance imerekebishwa`);
  
      loadData();
    } catch (err) {
      console.error(err);
      showMessage("Error");
    }
  }



  // User mmoja aonekane mara moja tu
const uniqueBets = [];
const usernames = new Set();

bets.forEach((bet) => {
  if (!usernames.has(bet.username)) {
    usernames.add(bet.username);
    uniqueBets.push(bet);
  }
});
  // ==========================
  // RESET ALL
  // ==========================

  async function resetAll() {
    if (uniqueBets.length === 0) {
      showMessage("Hakuna users");
      return;
    }
  
    try {
      for (const item of uniqueBets) {
        const username = item.username;
        const user = users[username];
  
        if (!user) continue;
  
        const userBets = bets.filter(
          (bet) => bet.username === username
        );
  
        const updates = {
          ...balanceFields,
        };
  
        userBets.forEach((bet) => {
          const win = Number(bet.totalWin || 0);
  
          switch (bet.currency) {
            case "TZS":
              updates.tshBalance += win;
              break;
  
            case "USDT":
              updates.usdtBalance += win;
              break;
  
            case "KES":
              updates.KESBalance += win;
              break;
  
            case "UGX":
              updates.UGXBalance += win;
              break;
  
            case "RWF":
              updates.RWFBalance += win;
              break;
  
            case "BIF":
              updates.BIFBalance += win;
              break;
  
            case "ZMW":
              updates.ZMWBalance += win;
              break;
  
            case "MWK":
              updates.MWKBalance += win;
              break;
  
            case "MZN":
              updates.MZNBalance += win;
              break;
  
            case "USD":
              updates.USDBalance += win;
              break;
  
            case "SSP":
              updates.SSPBalance += win;
              break;
  
            case "BWP":
              updates.BWPBalance += win;
              break;
  
            case "MGA":
              updates.MGABalance += win;
              break;
  
            default:
              break;
          }
        });
  
        await updateDoc(
          doc(db, "users", user.id),
          updates
        );
      }
  
      showMessage("Balance zote zimerekebishwa");
  
      loadData();
    } catch (err) {
      console.error(err);
      showMessage("Error");
    }
  }

  return (
    <div className="admin-container">
      <h2>
        Admin Wrong Pay Reset
      </h2>

      <div
  style={{
    display: "flex",
    gap: "10px",
    marginBottom: "20px",
    flexWrap: "wrap",
  }}
>
  <input
    type="date"
    value={selectedDate}
    onChange={(e) => setSelectedDate(e.target.value)}
  />

  <input
    type="time"
    value={selectedTime}
    onChange={(e) => setSelectedTime(e.target.value)}
  />

  <button onClick={loadData}>
    Search
  </button>
</div>



      {message && (
        <h3 style={{ color: "green" }}>
          {message}
        </h3>
      )}

      {!loading && bets.length > 0 && (
        <button
          className="delete-btn"
          onClick={resetAll}
        >
          RESET ALL BALANCES
        </button>
      )}

      {loading ? (
        <p>Loading...</p>
      ) : bets.length === 0 ? (
        <p>No Bets</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>User</th>
              <th>Match</th>
              <th>Currency</th>
              <th>TSH</th>
              <th>USDT</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
          {uniqueBets.map((bet) => {
              const user =
                users[bet.username] || {};


              return (
                <tr key={bet.id}>
                  <td>{bet.username}</td>

                  <td>
                    {bet.teamA} vs {bet.teamB}
                  </td>

                  <td>{bet.currency}</td>

                  <td>
                    {Number(
                      user.tshBalance || 0
                    ).toLocaleString()}
                  </td>

                  <td>
                    {Number(
                      user.usdtBalance || 0
                    ).toLocaleString()}
                  </td>

                  <td>
                    <button
                      className="delete-btn"
                      onClick={() =>
                        resetUser(
                          bet.username
                        )
                      }
                    >
                      Reset Balance
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}